import { getTrade } from '../utils/getTrade';
export const getTradeRate = async (input, deps, relayChainMap) => {
    const args = {
        quoteOrRate: 'rate',
        buyAsset: input.buyAsset,
        receiveAddress: input.receiveAddress,
        sellAmountIncludingProtocolFeesCryptoBaseUnit: input.sellAmountIncludingProtocolFeesCryptoBaseUnit,
        sellAsset: input.sellAsset,
        sendAddress: input.sendAddress,
        accountNumber: input.accountNumber,
        affiliateBps: input.affiliateBps,
        xpub: 'xpub' in input ? input.xpub : undefined,
    };
    const ratesResult = await getTrade({ input: args, deps, relayChainMap });
    return ratesResult;
};
